import React from 'react';

interface StatusDisplayProps {
  status: {
    status: string;
    action?: string;
  };
  isVisible: boolean;
}

export const StatusDisplay: React.FC<StatusDisplayProps> = ({ status, isVisible }) => {
  if (!isVisible || status.status === 'idle') return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#f3f4f6',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#6b7280',
        margin: '8px 0',
      }}
    >
      <div
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: '#4f46e5',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}
      />
      {status.action || `AI is ${status.status}...`}
    </div>
  );
};
